import React, {Component} from 'react';
import classnames from 'classnames';
import {connect} from "react-redux";
import {Grid, Row, Col, Image} from 'react-bootstrap';
import './instruction.css';
import { FaCheckCircle, FaChevronDown, FaChevronUp } from "react-icons/fa";
import {setImage} from '../../redux/actionCreators';
import FooterContainer from '../../components/footer/FooterContainer';
import PageWithFooter from '../../components/page_with_footer/PageWithFooter';
import MainButton from '../../components/buttons/main_button/MainButton';
import CircularProgressBarStep from '../../components/circular_progress_bar_step/CircularProgressBarStep';

//TODO merge instruction with camera component.
class Instruction extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isAdvicesExpanded: false,
        };
    }

    componentDidMount() {
        this.props.setImage(undefined);
    }

    toggleAdvices = () => {
        this.setState(prevState => ({
            isAdvicesExpanded: !prevState.isAdvicesExpanded
        }));
    }

    render() {
        let icon;
        let advicesIcon;
        let epigraph = this.props.stepInfo.epigraph;
        if (this.props.stepInfo.icon) {
            icon = require(`../../resources/images/${this.props.stepInfo.icon}`).default;
        }
        if (this.props.stepInfo.advicesIcon) {
            advicesIcon = require(`../../resources/images/${this.props.stepInfo.advicesIcon}`).default;
        }
        if (this.props.stepInfo.epigraph !== '') {
            epigraph = <h2>{epigraph}</h2>
        }
        let buttonText = this.props.buttonText;
        if (this.props.stepInfo.buttonText && this.props.stepInfo.buttonText !== '') {
            buttonText = this.props.stepInfo.buttonText;
        }
        return (
            <div className={classnames(
                    'instruction',
                    'page-layout',
                    {[this.props.stepInfo.additionalClass]: this.props.stepInfo.additionalClass && this.props.stepInfo.additionalClass !== ''},
                )}
            >
                
                <PageWithFooter
                    footer={(
                        <FooterContainer>
                            <MainButton 
                                onClick={this.props.nextStep}
                                text={buttonText}
                            />
                        </FooterContainer>
                    )}
                >
                <Grid style={{width: '100%'}}>
                    <div className={'content'}>
                        {this.props.stepInfo.alertText && this.props.stepInfo.alertText !== '' &&
                            <div className={'alert'}>
                                <FaCheckCircle className='icon-success-step' color='#00875A' fontSize='18px' /> {this.props.stepInfo.alertText}
                            </div>
                        }
                        <div className={'break-top'}></div>
                        <Row>
                            <Col xs={12}>
                                <div className={'number'}>
                                    <CircularProgressBarStep />
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                {epigraph}
                                <h1 className={'title'}>{this.props.stepInfo.title}</h1>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <div className="image">
                                    <Image src={icon}/>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={12}>
                                <p className={'description'} dangerouslySetInnerHTML={{ __html: this.props.stepInfo.description }} />
                            </Col>
                            {this.props.stepInfo.additionalDescription &&  this.props.stepInfo.additionalDescription !== '' &&
                                <Col xs={12}>
                                    <p className={'description'} dangerouslySetInnerHTML={{ __html: this.props.stepInfo.additionalDescription }} />
                                </Col>
                            }
                            {this.props.stepInfo.additional &&  this.props.stepInfo.additional !== '' &&
                                <Col xs={12}>
                                    <div className={'alert-box'}>
                                        <span className={'warning-icon'}>!</span> 
                                        <p className={'additional'}>
                                            {this.props.stepInfo.additional}
                                        </p>
                                    </div>
                                </Col>
                            }
                            { this.props.stepInfo.advicesTitle && this.props.stepInfo.advices && this.props.stepInfo.advices.length && 
                                <Col xs={12}>
                                    <div className={'advices-container'}>
                                        <div className={'advices-header'} onClick={this.toggleAdvices}>
                                            {advicesIcon && <img src={advicesIcon} className={'advices-icon'} alt="advices icon" />}
                                            <span className={'advices-title'}>{this.props.stepInfo.advicesTitle}</span>
                                            {this.state.isAdvicesExpanded ? 
                                                <FaChevronUp className={'advices-chevron'} /> : 
                                                <FaChevronDown className={'advices-chevron'} />
                                            }
                                        </div>
                                        {this.state.isAdvicesExpanded && (
                                            <div className={'advices-content'}>
                                                <ul className={'advices-list'}>
                                                    {this.props.stepInfo.advices.map((advice, index) => (
                                                        <li key={index}>{advice}</li>
                                                    ))}
                                                </ul>
                                            </div>
                                        )}
                                    </div>
                                </Col>
                            }
                        </Row>
                    </div>
                
                </Grid>
                </PageWithFooter>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        stepInfo: state.stepInfo,
        image: state.image,
        background: state.background,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setImage(image) {
            dispatch(setImage(image));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Instruction);
